var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResizein(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 24 24",
    width: 18,
    height: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.71 15.15C4.39 15.15 4.13 15.41 4.13 15.74C4.13 16.06 4.39 16.32 4.71 16.32C4.85 16.32 5.57 16.32 6.86 16.32C4.96 18.22 3.9 19.28 3.69 19.49C3.46 19.72 3.46 20.09 3.69 20.31C3.8 20.43 3.95 20.48 4.1 20.48C4.25 20.48 4.4 20.43 4.51 20.31C4.72 20.11 5.75 19.07 7.62 17.21C7.62 18.42 7.62 19.09 7.62 19.22C7.62 19.55 7.88 19.81 8.2 19.81C8.52 19.81 8.78 19.55 8.78 19.22C8.78 18.88 8.78 16.08 8.78 15.74C8.78 15.41 8.52 15.15 8.2 15.15C7.5 15.15 5.06 15.15 4.71 15.15Z",
    id: "b1n7ilESAz"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.22 16.35C19.55 16.35 19.81 16.09 19.81 15.77C19.81 15.45 19.55 15.19 19.22 15.19C18.88 15.19 16.08 15.19 15.74 15.19C15.41 15.19 15.15 15.45 15.15 15.77C15.15 16.12 15.15 18.91 15.15 19.26C15.15 19.58 15.41 19.84 15.74 19.84C16.06 19.84 16.32 19.58 16.32 19.26C16.32 19.11 16.32 18.4 16.32 17.11C18.22 19.01 19.28 20.07 19.49 20.28C19.6 20.39 19.75 20.45 19.9 20.45C20.05 20.45 20.2 20.39 20.31 20.28C20.54 20.05 20.54 19.68 20.31 19.46C20.11 19.25 19.07 18.21 17.21 16.35C18.42 16.35 19.09 16.35 19.22 16.35Z",
    id: "e3h3d5M0TB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.38 6.77C16.38 5.56 16.38 4.89 16.38 4.75C16.38 4.43 16.12 4.17 15.8 4.17C15.48 4.17 15.22 4.43 15.22 4.75C15.22 5.1 15.22 7.89 15.22 8.24C15.22 8.56 15.48 8.82 15.8 8.82C16.15 8.82 18.94 8.82 19.29 8.82C19.61 8.82 19.87 8.56 19.87 8.24C19.87 7.92 19.61 7.66 19.29 7.66C19.15 7.66 18.43 7.66 17.14 7.66C19.04 5.76 20.1 4.7 20.31 4.49C20.54 4.26 20.54 3.89 20.31 3.66C20.09 3.44 19.72 3.44 19.49 3.66C19.08 4.08 18.04 5.11 16.38 6.77Z",
    id: "bCa4YBlGs"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.68 4.72C7.68 4.86 7.68 5.58 7.68 6.87C5.78 4.97 4.72 3.91 4.51 3.7C4.28 3.47 3.91 3.47 3.69 3.7C3.46 3.92 3.46 4.29 3.69 4.52C3.89 4.73 4.93 5.76 6.79 7.63C5.58 7.63 4.91 7.63 4.78 7.63C4.45 7.63 4.19 7.89 4.19 8.21C4.19 8.53 4.45 8.79 4.78 8.79C5.12 8.79 7.92 8.79 8.26 8.79C8.59 8.79 8.85 8.53 8.85 8.21C8.85 7.86 8.85 5.07 8.85 4.72C8.85 4.4 8.59 4.14 8.26 4.14C7.94 4.14 7.68 4.4 7.68 4.72Z",
    id: "e2vRxKr1Xa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.93 0C1.31 0 0 1.31 0 2.93C0 4.74 0 19.26 0 21.07C0 22.69 1.31 24 2.93 24C4.74 24 19.26 24 21.07 24C22.69 24 24 22.69 24 21.07C24 19.26 24 4.74 24 2.93C24 1.31 22.69 0 21.07 0C17.44 0 4.74 0 2.93 0ZM21.07 22.84C19.26 22.84 4.74 22.84 2.93 22.84C1.96 22.84 1.16 22.04 1.16 21.07C1.16 19.26 1.16 4.74 1.16 2.93C1.16 1.96 1.96 1.16 2.93 1.16C4.74 1.16 19.26 1.16 21.07 1.16C22.04 1.16 22.84 1.96 22.84 2.93C22.84 4.14 22.84 10.19 22.84 21.07C22.31 22.25 21.72 22.84 21.07 22.84Z",
    id: "e1ZZ5OKH5M"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1n7ilESAz",
    opacity: 1,
    fill: "#FFFFFF",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1n7ilESAz",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#FFFFFF",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e3h3d5M0TB",
    opacity: 1,
    fill: "#FFFFFF",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e3h3d5M0TB",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#FFFFFF",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bCa4YBlGs",
    opacity: 1,
    fill: "#FFFFFF",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bCa4YBlGs",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#FFFFFF",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e2vRxKr1Xa",
    opacity: 1,
    fill: "#FFFFFF",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e2vRxKr1Xa",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#FFFFFF",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e1ZZ5OKH5M",
    opacity: 1,
    fill: "#FFFFFF",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e1ZZ5OKH5M",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#FFFFFF",
    strokeWidth: 1,
    strokeOpacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResizein);
export default __webpack_public_path__ + "static/media/resizein.3244bb393f68be5292b58bd9b0aeff8b.svg";
export { ForwardRef as ReactComponent };